import { httpClient } from "../../../http-client";
import { UserDTO } from "../models/user.dto";
import { UserModel } from "../models/user.model";
import { ApiUrlBuilder } from "../../shared/constants/apiUrl";

const UserServiceImplementation = {
  getUserMe: (): Promise<UserModel> => {
    return httpClient
      .get(ApiUrlBuilder.getUser())
      .then((response) => {
        return response.json();
      })
      .then((response: unknown) => {
        const isUserDTO = (userDTO: any): userDTO is UserDTO =>
          "uid" in userDTO &&
          "email" in userDTO &&
          "firstName" in userDTO &&
          "lastName" in userDTO &&
          "organizations" in userDTO &&
          "accessToken" in userDTO;
        if (isUserDTO(response)) {
          return new UserModel(response.email, response.firstName, response.lastName, response.organizations);
        } else {
          const errorMsg = `response contains: ${JSON.stringify(response)}`;
          throw new Error(errorMsg);
        }
      })
      .catch((error) => {
        throw error;
      });
  },
};

export const UserService: Readonly<typeof UserServiceImplementation> = UserServiceImplementation;
